import AuthStatusMixin from "./AuthStatusMixin"
import LocaleMixin from "./LocaleMixin"
import ModalMixin from "./ModalMixin"
import ErrorApiMixin from "./ErrorApiMixin"
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA"

export default {
    mixins: [AuthStatusMixin, LocaleMixin, ModalMixin, ErrorApiMixin],
    data: function() {
        return {
            userConsent: null,
            currentVersion: null,
            isLoadingGetVersion: false,
            isLoadingGetCurrentVersion: false,
            marketingOption: null,
        }
    },
    methods: {
        checkConsent: async function() {
            console.log("checkConsent")

            if (!this.isLoginAccount) {
                return
            }
            await this.getVersion()
            await this.getCurrentVersion()

            if (this.userConsent == null || this.currentVersion == null) {
                return
            }

            let termsChanged = await this.acceptTerms()
            let privacyChanged = await this.acceptPrivacy()
            let marketingChanged = await this.acceptMarketing()

            if (termsChanged || privacyChanged || marketingChanged) {
                await this.acceptConsent()
            }

        },

        getVersion: function() {
            if (this.isLoadingGetVersion) {
                return
            }
            this.isLoadingGetVersion = true
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe({
                    next: (response) => {
                        this.currentVersion = response
                        this.isLoadingGetVersion = false
                        resolve(true)
                    },
                    error: (error) => {
                        this.isLoadingGetVersion = false
                        this.showError(error)
                        reject(null)
                    }
                })
            })
        },
        getCurrentVersion: function() {
            if (this.isLoadingGetCurrentVersion) {
                return
            }
            this.isLoadingGetCurrentVersion = true
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetConsent().subscribe({
                    next: (response) => {
                        this.userConsent = response
                        this.isLoadingGetCurrentVersion = false
                        resolve(true)
                    },
                    error: (error) => {
                        this.isLoadingGetCurrentVersion = false
                        this.showError(error)
                        reject(null)
                    }
                })
            })
        },
        acceptTerms: function() {
            return new Promise((resolve) => {
                if (this.userConsent.TermAndCondition == parseInt(this.currentVersion.terms.current_version)) {
                    resolve(false)
                } else {
                    this.modal.pdpaModal.clearModal()
                        .setTitle(this.lbl.consent.terms)
                        .setType('terms')
                        .setBtnOk(this.lbl.consent.accept)
                        .show();
                    this.modal.pdpaModal.onClickOk(() => {
                        resolve(true)
                    })
                }
            })
        },
        acceptPrivacy: function() {
            return new Promise((resolve) => {
                if (this.userConsent.DataPrivacy == parseInt(this.currentVersion.privacy.current_version)) {
                    resolve(false)
                } else {
                    this.modal.pdpaModal.clearModal()
                        .setTitle(this.lbl.consent.privacy)
                        .setType('privacy')
                        .setBtnOk(this.lbl.consent.accept)
                        .show();
                    this.modal.pdpaModal.onClickOk(() => {
                        resolve(true)
                    })
                }
            })
        },
        acceptMarketing: function() {
            return new Promise((resolve) => {
                if (this.userConsent.TermAndCondition == parseInt(this.currentVersion.terms.current_version)) {
                    resolve(false)
                } else {
                    this.modal.pdpaModal.clearModal()
                        .setTitle(this.lbl.consent.marketing)
                        .setType('marketing')
                        .setBtnOk(this.lbl.consent.accept)
                        .show();
                    this.modal.pdpaModal.onClickOk(() => {
                        resolve(true)
                    })
                    this.modal.pdpaModal.onClickCancel(() => {
                        resolve(true)
                    })
                }
            })
        },

        acceptConsent: function() {
            return new Promise((resolve, reject) => {
                let params = {
                    termandcondition: parseInt(this.currentVersion.terms.current_version),
                    dataprivacy: parseInt(this.currentVersion.privacy.current_version),
                    marketingOption: parseInt(this.currentVersion.marketingOption.current_version),
                }
                BzbsPDPA.apiPostConsent(params.termandcondition, params.dataprivacy, params.marketingOption).subscribe({
                    next: (response) => {
                        console.log("acceptConsent", response)
                        resolve(true)
                    },
                    error: (error) => {
                        this.showError(error)
                        reject(null)
                    }
                })
            })
        }
    }

}